import brandToLangFormatter from './brandToLangFormatter/brandToLangFormatter';
import brandToWarpCssFormatter from './brandToWarpCssFormatter/brandToWarpCssFormatter';

export default {
    brandToLangFormatter,
    brandToWarpCssFormatter,
};
